module.exports = __webpack_public_path__ + "9c739a897e3f7945f6aa863c2b5bc880.svg";